import React, { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

interface RoleProtectedRouteProps {
  children: ReactNode;
  allowed: Array<"Admin" | "Colaborador" | "Comum">;
  redirectTo?: string; // optional custom redirect
}

// Wrapper that requires authentication AND specific role(s)
const RoleProtectedRoute: React.FC<RoleProtectedRouteProps> = ({
  children,
  allowed,
  redirectTo = "/",
}) => {
  const { isAuthenticated, loading, user } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
        }}
      >
        <div>Carregando...</div>
      </div>
    );
  }

  if (!isAuthenticated) return <Navigate to={redirectTo} replace />;

  if (user?.tipo && allowed.includes(user.tipo)) return <>{children}</>;

  // Authenticated but not authorized: redirect to their own profile route if possible
  return <Navigate to={redirectTo} replace />;
};

export default RoleProtectedRoute;
